/*
 * Handles our anti-clickjacking code. Prevents a page from being embedded in
 * a non-donorschoose page as an iframe, allows it to be embedded in a
 * donorschoose page, and allows it to embed donorschoose pages.
 *
 * In most cases, our CSP is our primary line of defense against clickjacking.
 * I'm keeping this around as defense-in-depth, though.
 */

(function () {
    /** VERY IMPORTANT!  Update with new domains
     */
    function isFromUs(origin) {
        const pattern = /^.*?\.donorschoose\.(org|net)$/;
        // Only accept messages from donorschoose
        return pattern.test(origin);
    }

    if (self !== top) {
        hideEverything(); // adds CSS to hide body
        top.postMessage('unblock-request', '*');
    }

    // See https://stackoverflow.com/questions/524696/how-to-create-a-style-tag-with-javascript
    function hideEverything() {
        const css = 'body { display: none; }';
        const style = document.createElement('style');
        style.type = 'text/css';
        style.id = 'antiClickjack';
        if (style.stylesheet) {
            style.stylesheet.cssText = css;
        } else {
            style.appendChild(document.createTextNode(css));
        }

        document.querySelector('head').appendChild(style);
    }

    window.receiveMessage = function (event) {
        if (!isFromUs(event.origin)) return;

        if (event.data === 'unblock-request') {
            event.source.postMessage('unblock', event.origin);
        } else if (event.data === 'unblock') {
            showEverything(); // removes CSS added by hideEverything();
        }
    };

    function showEverything() {
        const antiClickjack = document.getElementById('antiClickjack');
        if (antiClickjack !== null) {
            antiClickjack.parentNode.removeChild(antiClickjack);
        }
    }
})();
